/* unplugin-vue-components disabled */import { render } from "./mobile-input.vue?vue&type=template&id=2448bbea&scoped=true"
import script from "./mobile-input.vue?vue&type=script&lang=js"
export * from "./mobile-input.vue?vue&type=script&lang=js"

import "./mobile-input.vue?vue&type=style&index=0&id=2448bbea&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2448bbea"],['__file',"src/components/chat-input-v2/mobile-input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2448bbea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2448bbea', __exports__)) {
    api.reload('2448bbea', __exports__)
  }
  
  module.hot.accept("./mobile-input.vue?vue&type=template&id=2448bbea&scoped=true", () => {
    api.rerender('2448bbea', render)
  })

}


export default __exports__